import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { toastAlert } from "../../lib/toastAlert";
import { AddNFTlist, getnftlist } from '../../actions/users';
import { useParams, useNavigate } from "react-router-dom";

const initialFormValue = {
    'nftag': "",
}

const AddNFT = () => {

    const navigate = useNavigate();
    const { id } = useParams()
    const [formValue, setFormValue] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});

    useEffect(() => {
        getnftdata();
    }, [])

    const getnftdata = async () => {
        if (id && id != "") {
            var postdata = {
                id: id
            }
            var test = await getnftlist(postdata);
            if (test && test.userValue && test.userValue[0].nfttag) {
                let formdata = {};
                formdata['nfttag'] = test.userValue[0].nfttag;
                setFormValue(formdata)
            }
        }
    }

    const onChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        let formData = { ...formValue, ...{ [id]: value } }
        setFormValue(formData)
    }

    const {
        nfttag
    } = formValue

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        let reqData = {
            id,
            nfttag
        }

        var data = await AddNFTlist(reqData);

        if ((data)) {
            toastAlert("success", 'NFT details added');
            setTimeout(
                () => window.location.href = '/nfttag'
                , 1000)

        } else {
            setValidateError({});
        }

    }

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Edit sharing NFT tag'} />
                        <div className='common_page_scroller mt-5 pe-2'>
                            <button className='btn addcate' onClick={() => navigate(-1)}>Back</button>

                            <form noValidate onSubmit={handleFormSubmit}>
                                <div className="addcategorys">
                                    <h4>{id !== "" ? 'Edit' : 'Add'} sharing NFT tag</h4>
                                </div>

                                <div className="categorylisdt">
                                    <div className='row'>
                                    <div className='col-xl-7 mt-4 mb-3'>
                                            <label className='mb-2'>NFT Tag Name</label>
                                            <input
                                                className='form-control'
                                                type="text"
                                                id="nfttag"
                                                value={nfttag || ""}
                                                onChange={onChange}
                                                fullWidth
                                            />
                                            {validateError.nfttag && (
                                                <span className="text-danger">{validateError.nfttag}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <button className='btn addcate mt-3 mb-4 ms-2' type="submit">Add</button>
                                </div>
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default AddNFT